/** @file Tells whether Ctrl, Cmd or Alt is held: those chords are not a widget's to consume. */

/** The modifier flags of a keyboard event. */
export interface ModifierState {
  ctrlKey: boolean;
  metaKey: boolean;
  altKey: boolean;
}

/** True when the key press carries Ctrl, Cmd or Alt (Shift alone does not count). */
export function hasCommandModifier(e: ModifierState): boolean {
  return e.ctrlKey || e.metaKey || e.altKey;
}
